export const SUPPORTS_OBJECT_IS = "is" in Object;
